<template>
  <b-card>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form @submit.prevent="handleSubmit(onSubmit)" enctype="multipart/form-data">
        <b-row>
          <b-col cols="12">
            <validation-provider #default="validationContext" name="Current Password" rules="required">
              <b-form-group label="Current Password">
                <b-form-input placeholder="Current Password" v-model="dataInfo.current_password" type="password" :state="getValidationState(validationContext)" trim/>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider #default="validationContext" name="New Password" rules="required">
              <b-form-group label="New Password">
                <b-form-input placeholder="New Password" v-model="dataInfo.new_password" type="password" :state="getValidationState(validationContext)" trim/>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <validation-provider #default="validationContext" name="New Password Confirm" rules="required">
              <b-form-group label="New Password Confirm">
                <b-form-input placeholder="New Password Confirm" v-model="dataInfo.new_password_confirm" type="password" :state="getValidationState(validationContext)" trim/>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <action-buttons :back-route="'home'"/>
      </b-form>
    </validation-observer>
    <Overlay :busy="busy"></Overlay>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BFormInvalidFeedback,
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {onUnmounted, ref} from '@vue/composition-api'
import {email, required} from "@core/utils/validations/validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import ActionButtons from "@/components/Form/ActionButtons.vue";
import Overlay from "@/components/Overlay.vue";
import {useToast} from "vue-toastification/composition";
import store from "@/store";
import storeModule from "@/views/common/account/store";
import {toastMessage} from "@core/utils/utils";

export default {
  components: {
    BFormInvalidFeedback,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,

    Overlay,
    ActionButtons,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      email,
    }
  },
  setup() {
    const STORE_MODULE_NAME = 'store'
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, storeModule)
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation()

    const toast = useToast()
    const busy = ref(false)

    const dataInfo = ref({
      current_password: '',
      new_password: '',
      new_password_confirm: ''
    })

    const onSubmit = () => {
      busy.value = true
      store.dispatch('store/changePassword', dataInfo.value).then(response => {
        toastMessage(toast, 'success', response.data.message)
        resetForm()
      }).catch(error => {
        toastMessage(toast, 'danger', error.response.data.error_message)
      }).finally(message => {
        busy.value = false
      })
    }

    return {
      refFormObserver,
      busy,

      dataInfo,

      onSubmit,
      getValidationState,
      resetForm,
    }
  },
}
</script>
